import { useState } from "react";
import { Phone, Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { COMPANY } from "@/data/site";

const NAV = [
  { label: "Services", href: "/#services", section: true },
  { label: "Why Us", href: "/#why", section: true },
  { label: "Service Areas", href: "/service-areas", section: false },
  { label: "Reviews", href: "/#reviews", section: true },
  { label: "FAQ", href: "/#faq", section: true },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const onHome = pathname === "/";

  const renderLink = (n, extraProps = {}) => {
    if (n.section) {
      const href = onHome ? n.href.replace("/", "") : n.href;
      return (
        <a
          key={n.href}
          href={href}
          data-testid={`navbar-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
          {...extraProps}
        >
          {n.label}
        </a>
      );
    }
    return (
      <Link
        key={n.href}
        to={n.href}
        data-testid={`navbar-link-${n.label.toLowerCase().replace(/\s/g, "-")}`}
        {...extraProps}
      >
        {n.label}
      </Link>
    );
  };

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 h-20 flex items-center justify-between">
        <Link to="/" data-testid="navbar-logo" className="flex items-center gap-3">
          <img
            src={COMPANY.logo}
            alt="Peak Plumbing logo"
            className="h-12 w-auto object-contain"
          />
          <span className="hidden sm:flex flex-col leading-none">
            <span className="font-display font-black text-xl tracking-tight text-[#1E3A5F]">
              Peak Plumbing
            </span>
            <span className="text-[10px] uppercase tracking-[0.18em] text-[#A88852] font-bold mt-1">
              Strive for the Peak
            </span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {NAV.map((n) =>
            renderLink(n, {
              className:
                "text-sm font-semibold text-slate-700 hover:text-[#A88852] transition",
            })
          )}
        </nav>

        <div className="flex items-center gap-3">
          <a
            data-testid="navbar-phone"
            href={`tel:${COMPANY.phoneTel}`}
            className="hidden sm:inline-flex items-center gap-2 text-sm font-bold text-[#1E3A5F] hover:text-[#A88852] transition"
          >
            <Phone size={16} className="text-[#C5A572]" />
            {COMPANY.phone}
          </a>
          <a
            data-testid="navbar-cta"
            href={onHome ? "#quote" : "/#quote"}
            className="btn-cta hidden sm:inline-flex items-center px-4 py-2 text-sm"
          >
            Schedule an Appointment
          </a>
          <button
            onClick={() => setOpen((v) => !v)}
            data-testid="navbar-mobile-toggle"
            aria-label="Toggle menu"
            className="lg:hidden p-2 text-[#1E3A5F]"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="navbar-mobile-menu" className="lg:hidden border-t border-slate-200 bg-white">
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV.map((n) =>
              renderLink(n, {
                onClick: () => setOpen(false),
                className: "text-base font-semibold text-slate-700 py-2",
              })
            )}
            <a
              href={`tel:${COMPANY.phoneTel}`}
              className="inline-flex items-center gap-2 font-bold text-[#1E3A5F] py-2"
            >
              <Phone size={16} className="text-[#C5A572]" />
              {COMPANY.phone}
            </a>
            <a
              href={onHome ? "#quote" : "/#quote"}
              onClick={() => setOpen(false)}
              className="btn-cta inline-flex justify-center px-4 py-3 mt-2"
            >
              Schedule an Appointment
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
